import { RequestPayload } from "appworks/model/gameplay/requests/request-payload";

export class GambleRequestPayload extends RequestPayload {
    public choice?: string;
    public id: number;
}
